import React from "react";
import BannerBackground from "../Assets/home-banner-background.png";
import BannerImage from "../Assets/home.png";
import ResponsiveImage from "../Assets/prank.png";
import Navbar from "./Navbar";
import { FiArrowRight } from "react-icons/fi";

const Home = () => {
  return (
    <div className="home-container"> 
      <Navbar />
      <div className="home-banner-container">
        <div className="home-bannerImage-container">
          <img src={BannerBackground} alt="" /> 
        </div> 
        <div className="home-text-section">
          <h1 className="primary-heading">
          You can shed up to <span className="changeColor">15 kg in just 15 days</span>
          </h1>
          <p className="primary-text">
          Take the first step towards transforming your life today by enrolling in our specialized training program that <span className="changeColor">focuses on boosting your metabolism</span>
          </p>
          <button className="secondary-button">
            Order Now <FiArrowRight />{" "}
          </button>
        </div>
        <div className="home-image-section">
          <img src={BannerImage} alt="" />
        </div>
        <div className="home-image-responsive">
          <img src={ResponsiveImage} alt="" />
        </div>
      </div>
    </div> // Essa sessao serve para modificar o navbar do seu site
  );
};

export default Home;
